(() => {
  const STORAGE_KEY = 'accountPopupLastShown';

  class AccountPopupElement extends HTMLElement {
    constructor() {
      super();

      this._autoCloseTimeout = null;
      this._hovering = false;

      this._onMouseEnter = this._onMouseEnter.bind(this);
      this._onMouseLeave = this._onMouseLeave.bind(this);
      this._onCloseClick = this._onCloseClick.bind(this);
    }

    connectedCallback() {
      this.wrapper = this.querySelector('.account-popup-wrapper');
      this.closeBtn = this.querySelector('.account-popup--close');

      // listeners for desktop hover
      this.addEventListener('mouseenter', this._onMouseEnter);
      this.addEventListener('mouseleave', this._onMouseLeave);

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', this._onCloseClick);
      }

      // auto-show once per day (shared across all instances)
      this._maybeShowOnEnter();
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this._onMouseEnter);
      this.removeEventListener('mouseleave', this._onMouseLeave);
      if (this.closeBtn) {
        this.closeBtn.removeEventListener('click', this._onCloseClick);
      }
      this._clearAutoClose();
    }

    _todayString() {
      // local date, not UTC, avoids weird timezone re-triggers
      const d   = new Date();
      const y   = d.getFullYear();
      const m   = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`; // e.g. "2025-12-12"
    }

    _maybeShowOnEnter() {
      if (!this.wrapper) return;

      const today = this._todayString();

      try {
        const lastShown = window.localStorage.getItem(STORAGE_KEY);

        // If already shown today, do nothing
        if (lastShown === today) {
          return;
        }

        // Mark as shown today and open with timer
        window.localStorage.setItem(STORAGE_KEY, today);
        this._openWithTimer();
      } catch (e) {
        // localStorage unavailable (incognito, Safari, iframe, etc.)
        // -> don't auto-open, but hover still works
        return;
      }
    }

    _open() {
      this.classList.add('is-open');
    }

    _close() {
      this.classList.remove('is-open');
    }

    _openWithTimer() {
      this._open();
      this._clearAutoClose();
      this._autoCloseTimeout = window.setTimeout(() => {
        if (!this._hovering) {
          this._close();
        }
        this._autoCloseTimeout = null;
      }, 5000);
    }

    _clearAutoClose() {
      if (this._autoCloseTimeout) {
        window.clearTimeout(this._autoCloseTimeout);
        this._autoCloseTimeout = null;
      }
    }

    // events ---------------------------------------------------

    _onMouseEnter() {
      this._hovering = true;
      // user is interacting, don't auto close after 5s anymore
      this._clearAutoClose();
    }

    _onMouseLeave() {
      this._hovering = false;
      // when user leaves, if it was JS-open, close it
      if (this.classList.contains('is-open')) {
        this._close();
      }
    }

    _onCloseClick(event) {
      event.preventDefault();
      this._hovering = false;
      this._clearAutoClose();
      this._close();

      // Desktop: force :hover to drop immediately.
      this.style.pointerEvents = 'none';
      requestAnimationFrame(() => {
        this.style.pointerEvents = '';
      });
    }
  }

  if (!customElements.get('account-popup')) {
    customElements.define('account-popup', AccountPopupElement);
  }
})();
